var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0093DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61625 8.99999L10.5266 11.9981L12.3632 10.1064C12.4391 10.0272 12.5303 9.96416 12.6312 9.9211C12.7321 9.87803 12.8407 9.85583 12.9504 9.85583C13.0602 9.85583 13.1688 9.87803 13.2697 9.9211C13.3706 9.96416 13.4618 10.0272 13.5377 10.1064C13.6939 10.2692 13.7811 10.4861 13.7811 10.7117C13.7811 10.9373 13.6939 11.1541 13.5377 11.3169L11.1139 13.8144C11.0375 13.8929 10.9463 13.9554 10.8454 13.998C10.7445 14.0406 10.6361 14.0626 10.5266 14.0626C10.4171 14.0626 10.3087 14.0406 10.2079 13.998C10.107 13.9554 10.0157 13.8929 9.93937 13.8144L6.44288 10.2111V12.3531C6.44288 12.8233 6.06825 13.2092 5.61206 13.2092C5.15306 13.2092 4.78125 12.8256 4.78125 12.3531V5.64749C4.78125 5.17499 5.15306 4.79136 5.61206 4.79136C6.0705 4.79136 6.44288 5.17499 6.44288 5.64749V7.78949L9.93937 4.18611C10.0157 4.1076 10.107 4.04518 10.2079 4.00257C10.3087 3.95995 10.4171 3.93799 10.5266 3.93799C10.6361 3.93799 10.7445 3.95995 10.8454 4.00257C10.9463 4.04518 11.0375 4.1076 11.1139 4.18611L13.5382 6.68361C13.6945 6.84639 13.7817 7.06326 13.7817 7.28886C13.7817 7.51447 13.6945 7.73134 13.5382 7.89411C13.4623 7.97351 13.3711 8.0367 13.2701 8.07987C13.169 8.12304 13.0603 8.1453 12.9504 8.1453C12.8406 8.1453 12.7318 8.12304 12.6308 8.07987C12.5298 8.0367 12.4386 7.97351 12.3626 7.89411L10.5266 6.00186L7.61625 8.99999ZM10.5278 8.1433C10.9867 8.1433 11.3591 8.52693 11.3591 8.99999C11.3591 9.47305 10.9867 9.85668 10.5278 9.85668C10.0687 9.85668 9.69638 9.47305 9.69638 8.99999C9.69638 8.52693 10.0687 8.1433 10.5278 8.1433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcs);
export default __webpack_public_path__ + "static/media/kcs.fc100c723f8175867b4a721defe6127a.svg";
export { ForwardRef as ReactComponent };